// -----------------------------------------------------------------------------
// Scripts for sticky header
// -----------------------------------------------------------------------------

$(function () {
	$(window).on('scroll', function () {
		if ($(window).scrollTop() > 200) {
			$('.header').addClass('header--sticky');
			$('body').addClass('sticky-header');
		} else {
			$('.header').removeClass('header--sticky');
			$('body').removeClass('sticky-header');
		}
	});
	$(window).trigger('scroll');
});